var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"institutional-qnr-view view"},[_c('router-view',{attrs:{"sections":_vm.withQuestionNumbers,"context":_vm.context,"adminResponses":_vm.adminResponses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }